
// Add load callbacks...
//[STORE]?.deviceLoadCallbacks?.push([ ( _event ) => { console.log( 'load cb test' ) }, null ]);

// Add resize callbacks...
//[STORE]?.deviceResizeCallbacks?.push([ ( _event ) => { console.log( 'resize cb test' ) }, null ]);

// Add load listener...
//window?.addEventListener( 'DOMContentLoaded', [STORE]?.deviceLoad );

// Add resize listener...
//window?.addEventListener( 'resize', [STORE]?.deviceResize );

// Trigger resize for init
//window?.dispatchEvent( new Event( 'resize' ) );

const deviceInit = ( _args ) => {

	if ( !window ) return;
	
	let device = 
	{
		deviceLoad: null,
		deviceLoadCallbacks: _args?.deviceLoadCallbacks ?? [],
		deviceResize: null,
		deviceResizeCallbacks: _args?.deviceResizeCallbacks ?? [],
		deviceResizeDebounceCallbacks: _args?.deviceResizeDebounceCallbacks ?? [],
		deviceResizeDebounce: null,
		deviceResizeDebounceTimeout: null,
		deviceNavigatorUserAgent: navigator?.userAgent ?? null,
		deviceNavigatorCookiesEnabled: navigator?.cookiesEnabled ?? null,
		deviceViewportChangeDebounce: false,
		deviceViewportSizes: _args?.deviceViewportSizes ?? {},
		deviceViewportWidth: null,
		deviceViewportHeight: null,
		deviceViewportPixelDensity: window.devicePixelRatio,
		deviceViewportPixelDensityPercent: ( window.devicePixelRatio * 100 ).toFixed(0),
		deviceUserAgent: null,
		deviceIs: null,
		deviceIsMobile: null,
		deviceIsMobileSized: null,
		deviceIsTablet: null,
		deviceIsTabletSized: null,
		deviceIsTouch: null,
		deviceIsTouchEmulated: null,
		deviceIsType: null,
		deviceIsSized: null,
		deviceIsPointer: null,
		deviceIsPrefersReducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
		deviceIsPrefersContrastNone: window.matchMedia('(prefers-contrast: none)').matches,
		deviceIsPrefersColorSchemeDark: window.matchMedia('(prefers-color-scheme: dark)').matches,
		deviceIsPrefersContrastMore: window.matchMedia('(prefers-contrast: more)').matches,
		deviceIsPrefersContrastLess: window.matchMedia('(prefers-contrast: less)').matches,
		deviceIsPrefersContrastCustom: window.matchMedia('(prefers-contrast: custom)').matches,
	}

	device.deviceUpdate = async () =>
	{
		// Handle device definitions
		device.deviceViewportWidth = window.outerWidth;
		device.deviceViewportHeight = window.outerHeight;
		device.deviceUserAgent = navigator.userAgent.toLowerCase();
		device.deviceIsPointer = (matchMedia('(pointer:fine)').matches) 
							? 'fine'
							: (matchMedia('(pointer:course)').matches)
							? 'coarse'
							: 'none'
		device.deviceIsMobile = /iphone|android|mobile/i.test( device.deviceUserAgent );
		device.deviceIsMobileSized = (window.innerWidth <= 767);
		device.deviceIsTablet = /(iphone|ipad|ipod|tablet|(android(?!.*mobile))|(devices(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(ip|ap|wp))))/.test( device.deviceUserAgent );
		device.deviceIsTabletSized = (window.innerWidth <= 1366)
		device.deviceIsTouch = ( 'ontouchstart' in window );
		device.deviceIsTouchEmulated = (!device.deviceIsTouch && ( device.deviceIsPointer === 'coarse' || device.deviceIsPointer === 'none' ) );
		device.deviceIs = device.deviceIsType = ( device.deviceIsMobile ) 
							? 'mobile' 
							: ( device.deviceIsTablet ) 
							? 'tablet' 
							: 'desktop';

		device.deviceIsSized = ( device.deviceIsMobileSized ) 
							? 'mobile' 
							: ( device.deviceIsTabletSized ) 
								? 'tablet' 
								: 'desktop';

		// Handle html classes
		document.querySelector('html').setAttribute('data-device-user-agent', device.deviceUserAgent );  
		document.querySelector('html').setAttribute('data-device-pointer', device.deviceIsPointer );                      
		document.querySelector('html').setAttribute('data-device-touch', device.deviceIsTouch );
		document.querySelector('html').setAttribute('data-device-touch-emulated', device.deviceIsTouchEmulated );
		document.querySelector('html').setAttribute('data-device-mobile', device.deviceIsMobile );
		document.querySelector('html').setAttribute('data-device', device.deviceIs );
		document.querySelector('html').setAttribute('data-device-type', device.deviceIsType );
		document.querySelector('html').setAttribute('data-device-sized', device.deviceIsSized );
	}


	// Handle resize debounce
	device.deviceResizeDebounce = ( _deviceResizeEvent, _deviceResizeTime ) => 
	{
		
		// Remove old...
		if ( device.deviceResizeDebounceTimeout ) 
		{
			clearTimeout( device.deviceResizeDebounceTimeout );
			device.deviceResizeDebounceTimeout = null;
		}

		// Set new...
		device.deviceResizeDebounceTimeout = setTimeout( async () => {
			
			// Loop through cb's
			if ( device.deviceResizeDebounceCallbacks.length > -1 )
			{

				device.deviceResizeDebounceCallbacks.forEach( ( _deviceResizeDebounceCallback ) => {

					_deviceResizeDebounceCallback[0].apply(this, (_deviceResizeDebounceCallback[1]) ? [_deviceResizeEvent, ..._deviceResizeDebounceCallback[1]] : [_deviceResizeEvent]);

				});
			}

		}, (_deviceResizeTime || 50), _deviceResizeEvent );

	}


	// Handle resize
	device.deviceResize = ( _event ) =>
	{
		
		device.deviceUpdate();

		// Non-debounced callbacks.
		if ( device.deviceResizeCallbacks.length > -1 )
		{
			
			device.deviceResizeCallbacks.forEach( ( _deviceResizeCallback ) => {
			
				_deviceResizeCallback[0].apply(this, (_deviceResizeCallback[1]) ? [_event, ..._deviceResizeCallback[1]] : [_event]);

			});
		}

		// Debounced callbacks.
		device.deviceResizeDebounce( _event, 100 );

		return;
	}

	// Add resize listener...
	window?.addEventListener( 'resize', device.deviceResize );


	// Handle load
	device.deviceLoad = ( _event ) => 
	{

		device.deviceUpdate();
		
		// Non-debounced callbacks.
		if ( device.deviceLoadCallbacks.length > -1 )
		{
			
			device.deviceLoadCallbacks.forEach( ( _deviceLoadCallback ) => {
			
			_deviceLoadCallback[0].apply(this, (_deviceLoadCallback[1]) ? [_event, ..._deviceLoadCallback[1]] : [_event, device]);

			});
		}

		return device;

	}


	return device.deviceLoad();

};

export { 
	deviceInit 
};